import React from 'react'

import Layout from '../components/layout'
import EnterpriseAIPage from '../components/enterprise-ai/EnterpriseAIPage'
import { ENTERPRISE_AI_EN } from '../constants/enterpriseAIContent'

const EnterpriseAIPageEn = () => (
  <Layout
    lang="en"
    title={ENTERPRISE_AI_EN.seo.title}
    meta={{
      description: ENTERPRISE_AI_EN.seo.description,
      'og:title': ENTERPRISE_AI_EN.seo.ogTitle,
      'og:description': ENTERPRISE_AI_EN.seo.ogDescription,
      'twitter:title': ENTERPRISE_AI_EN.seo.ogTitle,
      'twitter:description': ENTERPRISE_AI_EN.seo.ogDescription,
    }}
    heroBleedBackground
    rootProps={{ className: 'page enterprise-ai' }}
  >
    <EnterpriseAIPage lang="en" />
  </Layout>
)

export default EnterpriseAIPageEn
